import * as actionTypes from '../actions/actionsTypes';

const initialState = {
  scorePointDefsData: {
    data: []
  },
};

export const scorePointDefListReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.FETCH_SCORE_POINT_DEF_DATA:
      return {
        ...state,
        scorePointDefsData: action.payload,
      };
    case actionTypes.UPDATE_SCORE_POINT_DEF_DATA:
      return {
        ...state,
        scorePointDefsData: action.payload,
      };
    default:
      return state;
  }
};

